import { ReactNode, useRef, useState } from 'react';
import { Tooltip as TooltipBootstrap, Overlay } from 'react-bootstrap';

interface TooltipProps {
  children: ReactNode;
  delay?: number;
  id: string;
  text: string | ReactNode;
  placement?: 'top' | 'right' | 'bottom' | 'left';
  zIndex?: number;
}

const Tooltip = ({
  children,
  delay,
  id,
  text,
  placement,
  zIndex,
}: TooltipProps) => {
  const [show, setShow] = useState(false);
  const [target, setTarget] = useState(undefined);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const tooltip = (
    <TooltipBootstrap
      id={id}
      placement={placement}
      style={zIndex ? { zIndex } : {}}
    >
      {text}
    </TooltipBootstrap>
  );

  const handleMouseEnter = (event: any) => {
    timeoutRef.current = setTimeout(() => {
      setShow(true);
      setTarget(event.target);
    }, delay ?? 0);
  };

  const handleMouseLeave = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    setShow(false);
  };

  return (
    <span
      data-testid="tooltip-container"
      className="tooltip-container"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {children}
      <Overlay target={target} show={show} placement={placement}>
        {tooltip}
      </Overlay>
    </span>
  );
};

Tooltip.defaultProps = {
  delay: undefined,
  placement: 'top',
  zIndex: undefined,
};

export default Tooltip;
